<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.register.trucker.label.title')}}</h4>
                            </div>
                        </div>
                    </div>

                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{$t('string.msg.register.trucker.label.title')}}
                                </p>

                                <form>

                                    <div v-if="data._id" class="form-row">
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.product.brand.label.id')}}
                                            </label>
                                            <input type="text" readonly v-model="data._id" class="form-control">
                                        </div>
                                        <div v-if="data.status == 'ACTIVE'" class="form-group col-md-2">
                                            <button v-on:click="confirmArchive" class="text-dark-gray btn btn-warning w-100 mt-4">{{$t('string.msg.status.archive')}}</button>
                                        </div>
                                        <div v-else-if="data.status == 'ARCHIVED'" class="form-group col-md-2">
                                           <label for="inputAddress" class="col-form-label" style="color:orange">
                                               {{$t('string.msg.status.ARCHIVED')}}
                                            </label>
                                        </div>
                                        <div v-else-if="data.status == 'REJECTED'" class="form-group col-md-2">
                                           <label for="inputAddress" class="col-form-label" style="color:red">
                                               {{$t('string.msg.select.selector.rejected')}}
                                            </label>
                                        </div>
                                        <div v-if="data.status == 'ACTIVE'" class="form-group col-md-7 text-right">
                                            <button v-on:click="modalNotification" class="cursor-pointer btn btn-dark w-30 mt-4"> <em class="fa fa-bell"></em> <label class="cursor-pointer mt-1 ml-2"><strong> {{toUpperCase($t('string.msg.send.notification'))}}</strong></label></button>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.name')}}
                                            </label>
                                            <input type="text" v-model="data.firstName" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.name')">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.lastname')}}
                                            </label>
                                            <input type="text" v-model="data.lastName" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.lastname')">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.rg')}}
                                            </label>
                                            <input type="text" v-model="data.customerUser.rg" class="form-control" v-mask="['###########']" :placeholder="$t('string.msg.trucker.placeholder.rg')">
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.cpf')}}
                                            </label>
                                            <input type="text" v-model="data.customerUser.document" class="form-control" v-mask="['###.###.###-##']" :placeholder="$t('string.msg.trucker.placeholder.cpf')">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.phone')}}
                                            </label>
                                            <input type="text" v-model="data.primaryPhone" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.phone')" v-mask="['(##) ####-####', '(##) #####-####']">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.birthday')}}
                                            </label>
                                            
                                            <input type="text" v-model="data.customerUser.dateBirth" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.birthday')" v-mask="['##/##/####']">
                                          
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.gender')}}
                                            </label>
                                            <select v-model="data.customerUser.gender" class="form-control">
                                                <option :value="null" selected>{{$t('string.msg.trucker.label.gender.select')}}</option>
                                                <option value="M" selected>{{$t('string.msg.trucker.label.gender.male')}}</option>
                                                <option value="F">{{$t('string.msg.trucker.label.gender.female')}}</option>
                                            </select>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.cnh')}}
                                            </label>
                                            <input type="text" v-model="data.customerUser.cnh" class="form-control" v-mask="['############']" :placeholder="$t('string.msg.trucker.placeholder.cnh')">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.obs')}}
                                            </label>
                                            <input type="text" v-model="data.customerUser.obsCNH" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.obs')">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.plate')}}
                                            </label>
                                            <input type="text" v-model="data.customerUser.plate" onkeyup="this.value = this.value.toUpperCase();"  v-mask="['AAA #X##']" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.plate')">
                                        </div>

                                    </div>
                                    
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.company')}}
                                            </label>
                                            <select v-model="data.customerUser.company" class="form-control">
                                                <option value="-1" selected>{{$t('string.msg.element.select.selectitem')}}</option>
                                                <option :value="item._id" v-bind:key="item._id" v-for="item in companies">{{camelize(item.fantasyName)}}</option>
                                            </select>
                                        </div>

                                    </div>
                                    <br/>
                                    <div class="form-row">
                                        <!--<div v-if="data._id" class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.email')}}
                                            </label>
                                            <input type="text" disabled v-model="data.email" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.email')">
                                        </div>
                                        <div v-else class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.email')}}
                                            </label>
                                            <input type="text" v-model="data.email" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.email')">
                                        </div>-->

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.password')}}
                                            </label>
                                            <input type="password" v-model="data.password" class="form-control" :placeholder="$t('string.msg.trucker.placeholder.password')">
                                        </div>
                                    </div>
                                    <br>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.trucker.label.cnh-attachment')}}
                                            </label>
                                            <input type="file" accept="image/png, image/jpeg" id="cnh" ref="file" v-on:change="handleFileUpload()" class="form-control">
                                        </div>
                                        <div v-if="data.customerUser.cnhPhotoURL" class="form-group col-md-5"> 
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.photo.label')}}
                                            </label>
                                            <div class="card border border-secondary cursor-pointer">
                                                <div class="card-body text-secondary text-center">
                                                    <div v-if="data.customerUser.cnhPhotoURL" @click="showPhoto(data.customerUser.cnhPhotoURL)" class="card-body text-secondary text-center">
                                                        <img v-bind:src="`${domain}${data.customerUser.cnhPhotoURL}`" alt="image" height="180" width="250">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/>
                                    
                                    <div class="form" v-show="data._id">
                                        
                                        <div class="form-row">
                                            <div class="col-md-12">
                                                <h5>
                                                    {{$t('string.msg.modal.orders.truck.infos') + '(s)'}}
                                                </h5>
                                            </div>
                                        </div>

                                        <div class="table-responsive" v-if="trucks && trucks.length > 0">
                                            <table class="table table-centered table-hover mb-0" id="datatable">
                                                <thead>
                                                    <tr>
                                                        <th class="border-top-0">{{$t('string.msg.truck.table.header.vehicle.type')}}</th>
                                                        <th class="border-top-0">{{$t('string.msg.truck.table.header.manufacture')}}</th>
                                                        <th class="border-top-0">{{$t('string.msg.truck.table.header.model')}}</th>
                                                        <th class="border-top-0">{{$t('string.msg.truck.table.header.year')}}</th>
                                                        <th class="border-top-0">{{$t('string.msg.truck.table.header.Placa')}}</th>
                                                        <th class="border-top-0">{{$t('string.msg.list.trucks.table.certifieds')}}</th>
                                                        <th class="border-top-0"></th>
                                                    </tr>
                                                </thead>
                                                <tbody v-bind:key="item._id" v-for="item in trucks" class="cursor-pointer">
                                                    <tr v-if="item && item.status == 'ACTIVE'">
                                                        <td>
                                                            <span v-if="item.vehicleType">  
                                                                {{ $t(item.vehicleType).toString().toUpperCase()}}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span v-if="item.manufacturer">     
                                                                {{item.manufacturer.name}}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span v-if="item.model && item.model.name">
                                                                {{item.model.name}}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span v-if="item.year">
                                                             {{item.year}}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span v-if="item.plate">   
                                                             {{item.plate}}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span v-bind:key="item" v-for="item in item.certifies">   
                                                                {{item.certified.name + ' / '}}
                                                             </span>
                                                        </td>
                                                        <td>
                                                            <span>   
                                                                <button @click="editTruck(item)" class="btn btn-primary">{{$t('string.msg.btn.edit')}}</button>
                                                             </span> 
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div v-if="loadingVehicle"> 
                                            <div class="wavy">
                                                <span style="--i:1;">C</span>
                                                <span style="--i:2;">a</span>
                                                <span style="--i:3;">r</span>
                                                <span style="--i:4;">r</span>
                                                <span style="--i:5;">e</span>
                                                <span style="--i:6;">g</span>
                                                <span style="--i:7;">a</span>
                                                <span style="--i:8;">n</span>
                                                <span style="--i:9;">d</span>
                                                <span style="--i:10;">o</span>
                                                <span class="ml-1" style="--i:11;"></span>
                                                <span style="--i:12;">v</span>
                                                <span style="--i:13;">e</span>
                                                <span style="--i:14;">i</span>
                                                <span style="--i:15;">c</span>
                                                <span style="--i:16;">u</span>
                                                <span style="--i:17;">l</span>
                                                <span style="--i:18;">o</span>
                                                <span style="--i:19;">s</span>
                                                <span style="--i:20;">.</span>
                                                <span style="--i:21;">.</span>
                                                <span style="--i:22;">.</span>
                                            </div>
                                        </div>
                                        <div v-else-if="!loadingVehicle && trucks && trucks.length == 0" class="form-row">
                                            <div class="col-md-12">
                                                <h5 style="color:red">
                                                    {{$t('string.msg.user.type.customer.zero.trucks')}}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row mt-4">
                                        <div class="form-group col-md-6 text-center">
                                            <button @click="clearForm" class="btn btn-secondary w-50">{{$t('string.msg.form.btn.clear')}}</button>
                                        </div>

                                        <div class="form-group col-md-6 text-center">
                                            <button v-on:click="checkForm" class="btn btn-danger w-50">{{$t('string.msg.form.btn.save')}}</button>
                                        </div>
                                    </div>
                                    <div v-if="errors.length" class="alert alert-danger mt-2">
                                        <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                                        <ul>
                                            <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                                        </ul>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                    <List v-on:load-item="selectItem" />
                </div>
            </div>
        </div>

        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" v-on:confirmation-return="archive" />
        <Notification :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" :titleNotification="titleNotification" :description="description" v-on:confirmation-return="returnModal" />
        <Photo :photoURL="photoURL" />
        <FlashMessage/>
    </div>
</template>

<script>
import Controller from './CrtTrucker';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Photo from '../../../components/layout/ModalPhoto';
import Confirmation from '../../../components/layout/Confirmation';
import Notification from '../Modal/Notification';
import List from './ListTrucker';
import {ptBR} from 'vuejs-datepicker/dist/locale'
import Vue from 'vue';
Vue.prototype.$eventHub = new Vue();
Vue.use(require('vue-moment'));

let maxDate = new Date();
export default {
  name: 'TruckerFleetDriver',
  components: {
    Spinner,
    Toast,
    Photo,
    List,
    Confirmation,
    Notification
  },
  data() {
      return {
        errors: [],
         disabledDates: {
            from: maxDate, // Disable all dates before specific date
        },
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        photoURL: null,
        companies:[],
        ptBR: ptBR,
        loadingVehicle: false,
        trucks: null,
        truckers: [],
        nTruckers: null,
        datetime:null,
        titleNotification: null,
        description: null,
        notification: {},
        data: {
            firstName: null,
            lastName: null,
            email: null,
            password: null,
            primaryPhone: null,
            type: "USER-CUSTOMER",
            customerUser: {
                subtype: "TRUCK_DRIVER",
                dateBirth: null,
                document: null,
                cnh: null,
                rg: null,
                selfiePhotoURL: 'xxxxx',
                obsCNH: null,
                gender: null,
                company: null,
                plate: null
            }
        },
        truckTrailersTypes:["TRUCKTRAILER_VANDERLEIA", "TRUCKTRAILER_CONVENCIONAL" ,"TRUCKTRAILER_DOLLY"],
        truckTypes:["TRUCK_VUC", "TRUCK_TOCO" ,"TRUCK_TRUCK", "TRUCK_MECHANICAL_HORSE_SIMPLE", "TRUCK_MECHANICAL_HORSE_TRUCADO",
                    "TRUCK_MECHANICAL_HORSE_TRACADO", "TRUCK_DOUBLE_TRAIN","TRUCK_RODOTREM"]
    }
  },
  methods: Controller.methods,
  created() {
  },
  computed: {
  },
  mounted(){
      this.data.customerUser.company = this.$session.get('user').companyUser.company._id;
      Controller.init(this);
  }
}
</script>

<style>
    .wavy {
    position: relative;
    -webkit-box-reflect: below -10px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
    }
    .wavy span {
    position: relative;
    display: inline-block;
    color: #000;
    font-size: 1em;
    animation: animate 1.5s ease-in-out infinite;
    animation-delay: calc(.1s * var(--i))
    }
    @keyframes animate {
    0%, 100% {
        transform: translateY(0px);
    }
    20% {
        transform: translateY(-2px);
    }
    40% {
        transform: translateY(0px);
    }
    }
</style>
